import {
  AllRoleListSuccess,
  RoleListSuccess,
} from '../../actionTypes/roleActions';

const inititalState = {
  allRole: [],
  roleList: [],
};

export const roleReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case AllRoleListSuccess:
      return {
        ...state,
        allRole: payload,
      };
    case RoleListSuccess:
      return {
        ...state,
        roleList: payload,
      };
    default:
      return state;
  }
};
